import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import Modal from 'meinian-package/src/component/modal'
import Input from 'meinian-package/src/baseComponent/input'
import { message } from 'antd'
import './index.less'
import { request } from 'meinian-package/src/utils'

export default (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<FolderSet {...props} visible container={div} />, div)
  })
}

export const FolderSet = ({ visible, value, onCancel, onOk, onChange, title = '新建文件夹', type = 'create' }) => {
  const [_visible, set_Visible] = useState(visible)
  const [val, setVal] = useState({
    folderName: value?.folderName || '',
    remark: value?.remark || '',
    ...value,
  })

  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }
  const _ok = async () => {
    if (!val.folderName) {
      message.error('请输入必填项')
      return
    }
    const result = await fetchData(val)
    const flag = await onOk?.(result)
    if (flag === false) {
      return
    }
    set_Visible(false)
  }

  const fetchData = async (_params) => {
    if (type === 'edit') {
      const result = await request.post('/zhikuan/mn/sample/folder/update-folder', { ..._params })
      if (result) {
        message.success(`${title}成功`)
        onChange?.(result)
        return result
      }
    } else {
      const result = await request.post('/zhikuan/mn/sample/folder/save-folder', { ..._params })
      if (result) {
        message.success(`${title}成功`)
        onChange?.(result)
        return result
      }
    }
  }

  return <Modal
    style={{ width: '640px' }}
    visible={_visible}
    onCancel={_cancel}
    onOk={_ok}
    title={title}
  >
    <div className="mn-public-component-fun-modal-set-folder">
      <div className="item-name required">名称</div>
      <Input
        wrapClassName="item-input"
        maxLength={20}
        value={val.folderName}
        placeholder="请输入灵感集名称，不超过20个字"
        onChange={(e) => { setVal((pre) => ({ ...pre, folderName: e.target.value })) }}
        suffix={`${val.folderName?.length}/20`}
      />
      <div className="item-name">简介</div>
      <Input
        wrapClassName="item-input"
        maxLength={50}
        value={val.remark}
        placeholder="请输入简介，不超过50个字"
        onChange={(e) => { setVal((pre) => ({ ...pre, remark: e.target.value })) }}
        suffix={`${val.remark?.length}/50`}
      />
    </div>
  </Modal>
}
